import { render, staticRenderFns } from "./newsFooter.vue?vue&type=template&id=3e65d21f&"
import script from "./newsFooter.vue?vue&type=script&lang=js&"
export * from "./newsFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports